import React from 'react';
import LegalLayout, { H2, P, UL } from '@/components/LegalLayout';

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updatedOn="May 27, 2026">
      <P>
        These Terms of Service ("Terms") govern your access to and use of BILL4PE, an
        AI-powered expense, invoice and reimbursement platform operated under the brand
        www.bill4pe.com (the "Service"). By creating an account or using the Service, you
        agree to these Terms.
      </P>

      <H2>1. The Service</H2>
      <P>
        BILL4PE lets you capture expenses, detect items from photos using AI, scan UPI QR
        codes, record payment details, and generate professional PDF invoices for corporate
        reimbursement. Wallet recharge in version 1 is currently in mock/test mode.
      </P>

      <H2>2. Eligibility</H2>
      <UL>
        <li>You are 18 years or older.</li>
        <li>You have the authority to bind yourself (and where applicable, your employer)
            to these Terms.</li>
        <li>Your jurisdiction allows you to use a UPI-based service.</li>
      </UL>

      <H2>3. Your account</H2>
      <UL>
        <li>Keep your login credentials and OTP confidential.</li>
        <li>You are responsible for every action performed under your account.</li>
        <li>Notify us immediately of any unauthorised use.</li>
      </UL>

      <H2>4. Acceptable use</H2>
      <P>You agree NOT to:</P>
      <UL>
        <li>Upload fraudulent, manipulated or fabricated bill images.</li>
        <li>Generate invoices for transactions that did not actually occur.</li>
        <li>Attempt to reverse-engineer, scrape, or interfere with the Service.</li>
        <li>Use the Service for any illegal, abusive or unauthorised purpose.</li>
      </UL>

      <H2>5. Fees</H2>
      <UL>
        <li>Creating an account and capturing expenses is free.</li>
        <li>Bill generation costs <b>1% of the bill amount (minimum ₹1)</b>, deducted from your in-app wallet.</li>
        <li>Wallet top-ups (when payment gateway is enabled) are processed by a licensed
            payment partner. Top-up amounts are non-refundable once credited, except where
            required by law.</li>
        <li>We may revise fees with at least 14 days' prior notice via in-app message or email.</li>
      </UL>

      <H2>6. Invoices generated by you</H2>
      <P>
        You retain full ownership of the expense data and invoices you create. BILL4PE is the
        tool; the authenticity, accuracy and legitimacy of the contents are your responsibility.
        Generated PDFs include a "system-generated via BILL4PE" disclosure as required.
      </P>

      <H2>7. AI limitations</H2>
      <P>
        Our AI detects items and estimates prices from photos to save you typing — it is not
        infallible. Always review the editable item list before paying or generating an
        invoice. We do not warrant that AI-extracted data is free of errors.
      </P>

      <H2>8. UPI payments</H2>
      <P>
        BILL4PE is NOT a payment system or PSP. You pay the merchant directly in your
        installed UPI app (GPay, PhonePe, Paytm, BharatPe, BHIM, etc.) and upload the
        payment receipt here for automatic verification. The actual money transfer
        happens entirely within your UPI app and the NPCI rails. We only
        capture the transaction details verified from your receipt after the payment completes.
      </P>

      <H2>9. Availability</H2>
      <P>
        We aim for 99.5% uptime but cannot guarantee uninterrupted service. We may suspend
        the Service for maintenance, security or legal reasons with reasonable notice where
        possible.
      </P>

      <H2>10. Intellectual property</H2>
      <P>
        The BILL4PE name, logo, design, source code and underlying technology are owned by
        us. You receive a limited, non-exclusive, non-transferable, revocable licence to use
        the Service for personal or internal business purposes. You may not resell, sublicence
        or republish the Service.
      </P>

      <H2>11. Limitation of liability</H2>
      <P>
        To the maximum extent permitted by law, BILL4PE shall not be liable for indirect,
        incidental, special, consequential or punitive damages, including loss of revenue,
        profits, data or goodwill arising from your use of the Service. Our aggregate
        liability shall not exceed the fees you paid to us in the 3 months preceding the
        claim.
      </P>

      <H2>12. Termination</H2>
      <UL>
        <li>You can delete your account at any time via the app or by emailing us.</li>
        <li>We may suspend or terminate accounts that violate these Terms.</li>
        <li>On termination, your right to use the Service ends but accrued rights
            (e.g. invoices already generated and downloaded) survive.</li>
      </UL>

      <H2>13. Governing law</H2>
      <P>
        These Terms are governed by the laws of India. Courts in Ghaziabad, Uttar Pradesh - 201010
        shall have exclusive jurisdiction over any disputes, subject to applicable
        consumer-protection provisions.
      </P>

      <H2>14. Changes</H2>
      <P>
        We may revise these Terms. Material changes will be communicated via email or in-app
        notification. Continued use after the effective date means you accept the revised Terms.
      </P>

      <H2>15. Contact</H2>
      <P>
        Questions? Visit our{' '}
        <a href="/contact" className="text-brand underline">Contact page</a>{' '}
        or email <span className="text-brand">legal@bill4pe.com</span>.
      </P>
      <P>
        <b>Registered correspondence:</b><br />
        Ujjwal Gupta, Plot No. 239, Second Floor, Saraswati Lane,<br />
        Sector - 5, Vaishali, Ghaziabad, Uttar Pradesh - 201010<br />
        Mobile: +91 70111 84609
      </P>
    </LegalLayout>
  );
}
